import _ from 'lodash';

export const getLookupObject = (arr, fieldName) => _.chain(arr)
  .map((mb) => mb[fieldName])
  .uniq()
  .sort()
  .reduce((acc, u) => ({
    ...acc,
    [u]: u,
  }), {})
  .value();

export const getRenderedLookupObject = (arr, fieldName) => _.chain(arr)
  .uniqBy((e) => e[fieldName])
  .sort()
  .reduce((acc, u) => ({
    ...acc,
    [u.id]: u[fieldName],
  }), {})
  .value();
